<template>
  <button class="summary" @click="$emit('click')">
    <span>Resumen</span><img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_play.png" />
  </button>
</template>

<script>
export default {
  name: 'ButtonSummary',
};
</script>

<style scoped lang="scss">
.summary {
  width: 72px;
  height: 22px;
  border-radius: 25px;
  background-color: #cbee6d;
  border: solid 1px #cbee6d;
  display: inline-flex;
  font-family: 'Avenir-Medium', sans-serif;
  font-size: 11px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 22px;
  letter-spacing: -0.22px;
  text-align: center;
  color: #132839;
  justify-content: center;
  span {
    cursor: pointer;
  }
  & > img {
    width: 14px;
    height: 14px;
    margin-top: 4px;
    margin-left: 6px;
    cursor: pointer;
  }
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
}
</style>
